import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getTelemetryPercentages,
  getUsersGroupedByTelemetryField,
  TelemetryGroupByField,
  TelemetryGroupByFieldResponse,
  TelemetryPercentagesResponse,
} from '../../api/awsApis'

export const fetchTelemetryGroupedByField = createAsyncThunk<
  TelemetryGroupByFieldResponse,
  TelemetryGroupByField,
  { rejectValue: string }
>(
  'analytics/fetchTelemetryGroupedByField',
  async (field, { rejectWithValue }) => {
    try {
      return await getUsersGroupedByTelemetryField(field)
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : 'Failed to fetch analytics data',
      )
    }
  },
)

export const fetchTelemetryPercentages = createAsyncThunk<
  TelemetryPercentagesResponse,
  void,
  { rejectValue: string }
>(
  'analytics/fetchTelemetryPercentages',
  async (_, { rejectWithValue }) => {
    try {
      return await getTelemetryPercentages()
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : 'Failed to fetch analytics percentages',
      )
    }
  },
)
